import React, { useState } from 'react';
import SuiviDuMarche from '../SuiviDuMarche/SuiviDuMarche';
import Consultation from '../Consultation/Consultation';
import ConsultationBC from '../ConsultationBC/ConsultationBC';
import Candidature from '../Candidature/Candidature';
import Analyse from '../Analyse/Analyse';
import Marche from '../Marche/Marche';
import OffreBC from '../OffreBC/OffreBC';
import { calculateFinancialScore, getNoteGlobale, isAcheteurSignataire } from '../../utils/entityUtils';
import { useBCActions } from '../../hooks/useBCActions';
import { useSuiviEntityTabs } from '../../hooks/useSuiviEntityTabs';
import OffreBCI from '../OffreBCI/OffreBCI';

interface SuiviEntityContentProps {
  entity: any;
  setEntity: React.Dispatch<React.SetStateAction<any>>;
  activeTab: number;
  commandeType: 'MS' | 'BC' | 'BCI';
  isClientView: boolean;
  isPrestataireView: boolean;
  selectedPrestataire: number | null;
  setSelectedPrestataire: React.Dispatch<React.SetStateAction<number | null>>;
  techNotes: any;
  setTechNotes: React.Dispatch<React.SetStateAction<any>>;
  errors: any;
  setErrors: React.Dispatch<React.SetStateAction<any>>;
  acceptCGV: boolean;
  setAcceptCGV: React.Dispatch<React.SetStateAction<boolean>>;
  handleExport: () => Promise<void>;
  validateConsultationForm: () => boolean;
  handleLancerConsultation: () => Promise<void>;
  handleFinaliserCommande: (id_signataire?: number, type_signataire?: string) => Promise<void>;
  entityType: 'operation' | 'commande';
  printRef?: any;
}

const SuiviEntityContent: React.FC<SuiviEntityContentProps> = ({
  entity,
  setEntity,
  activeTab,
  commandeType,
  isClientView,
  isPrestataireView,
  selectedPrestataire,
  setSelectedPrestataire,
  techNotes,
  setTechNotes,
  errors,
  setErrors,
  acceptCGV,
  setAcceptCGV,
  handleExport,
  validateConsultationForm,
  handleLancerConsultation,
  handleFinaliserCommande,
  entityType,
  printRef
}) => {
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);

  const { tabs: entityTabs } = useSuiviEntityTabs(entity, {
    entityType,
    getCommandeType: () => commandeType
  });

  const tabs = entityTabs;

  // Hook pour les actions BC
  const {
    handleLancerConsultation: handleLancerConsultationBC,
    handleAccepterCommande,
    handleRefuserCommande
  } = useBCActions(entity?.id);

  // CORRECTION: Logique adaptée pour les BC avec gestion du statut "Brouillon Acheteur"
  const getIsConsultationReadOnly = () => {
    const status = entity.status?.nom || entity.status;

    if (commandeType === 'BC') {
      // CORRECTION: Pour les BC, en statut "Brouillon" ou "Brouillon Acheteur", l'acheteur peut modifier
      if (isClientView && (status === 'Brouillon' || status === 'Brouillon acheteur')) {
        console.log('=== ACHETEUR BC PEUT MODIFIER ===');
        console.log('Status:', status);
        console.log('Is client view:', isClientView);
        return false; // Modifiable pour l'acheteur
      }

      // Pour les prestataires BC, selon leur statut de consultation
      if (isPrestataireView) {
        return status !== 'En consultation';
      }

      // Autres cas BC : lecture seule
      return true;
    } else {
      // Logique MS existante
      return status !== 'Brouillon';
    }
  };

  const isConsultationReadOnly = getIsConsultationReadOnly();
  const status = entity.status?.nom || entity.status;
  const isAnalyseReadOnly = status === 'En attente de votre signature' ||
    status === 'Accepté' ||
    status === 'Refusé';

  const renderTabs = () => {
    console.log('=== DEBUG RENDER TABS SUIVI ENTITY CONTENT ===');
    console.log('Command type:', commandeType);
    console.log('Active tab:', activeTab);
    console.log('Tabs disponibles:', tabs);
    console.log('Entity:', entity);
    console.log('Is client view:', isClientView);
    console.log('Is prestataire view:', isPrestataireView);

    if (commandeType === 'MS') {
      if (isPrestataireView && activeTab === 2) {
        return (
          <Analyse
            commande={entity}
            techNotes={techNotes}
            setTechNotes={setTechNotes}
            selectedPrestataire={selectedPrestataire}
            setSelectedPrestataire={setSelectedPrestataire}
            isDetailsModalOpen={isDetailsModalOpen}
            setIsDetailsModalOpen={setIsDetailsModalOpen}
            handleExport={handleExport}
            calculateFinancialScore={calculateFinancialScore}
            getNoteGlobale={getNoteGlobale}
            handleFinaliserCommande={handleFinaliserCommande}
            viewOnly={isAnalyseReadOnly}
            canClotureAnalyse={isAcheteurSignataire()}
          />
        );
      }

      switch (activeTab) {
        case 0:
          return <SuiviDuMarche commande={entity} type="MS" />;
        case 1:
          if (isPrestataireView) {
            return (
              <Candidature
                commande={entity}
                setCommande={setEntity}
                handleExport={handleExport}
                viewOnly={status !== 'En consultation' && status !== 'Candidature en cours'}
              />
            );
          } else {
            return (
              <Consultation
                commande={entity}
                errors={errors}
                setErrors={setErrors}
                setCommande={setEntity}
                acceptCGV={acceptCGV}
                setAcceptCGV={setAcceptCGV}
                handleExport={handleExport}
                validateConsultationForm={validateConsultationForm}
                handleLancerConsultation={handleLancerConsultation}
                viewOnly={isConsultationReadOnly}
              />
            );
          }
        case 2:
          if (isClientView) {
            return (
              <Analyse
                commande={entity}
                techNotes={techNotes}
                setTechNotes={setTechNotes}
                selectedPrestataire={selectedPrestataire}
                setSelectedPrestataire={setSelectedPrestataire}
                isDetailsModalOpen={isDetailsModalOpen}
                setIsDetailsModalOpen={setIsDetailsModalOpen}
                handleExport={handleExport}
                calculateFinancialScore={calculateFinancialScore}
                getNoteGlobale={getNoteGlobale}
                handleFinaliserCommande={handleFinaliserCommande}
                viewOnly={isAnalyseReadOnly}
                canClotureAnalyse={isAcheteurSignataire()}
              />
            );
          }
          break;
        case 3:
          return <Marche operation={entity} selectedPrestataire={selectedPrestataire} />;
        default:
          return <div>Onglet non disponible</div>;
      }
    } else if (commandeType === 'BC') {
      // Logique pour BC
      if (isPrestataireView) {
        // Pour les prestataires BC : structure simplifiée
        switch (activeTab) {
          case 0: // Historique
            return <SuiviDuMarche commande={entity} type="BC" />;

          case 1: // Consultation
            const rangPrestataire = entity.rang_prestataire || entity.rang || 1;
            return (
              <ConsultationBC
                commande={entity}
                rang={rangPrestataire as 1 | 2 | 3}
                errors={errors}
                setErrors={setErrors}
                setCommande={setEntity}
                handleExport={handleExport}
                validateConsultationFormBC={validateConsultationForm}
                handleLancerConsultation={(r) => handleLancerConsultationBC(r, entity)}
                handleAccepterCommande={handleAccepterCommande}
                handleRefuserCommande={handleRefuserCommande}
                viewOnly={isConsultationReadOnly}
                acceptCGV={acceptCGV}
                setAcceptCGV={setAcceptCGV}
                printRef={printRef}
                commandeType={commandeType}
              />
            );

          case 2: // NOUVEAU: Offre pour prestataires BC
            console.log('=== RENDU ONGLET OFFRE BC PRESTATAIRE ===');
            console.log('Active tab:', activeTab);
            console.log('Entity:', entity);
            console.log('Rang prestataire:', entity.rang || 2);

            return (
              <OffreBC
                commande={entity}
                rang={entity.rang || 2}
                viewOnly={false}
                // NOUVEAU: Passer les props CGV
                acceptCGV={acceptCGV}
                setAcceptCGV={setAcceptCGV}
                printRef={printRef}
              />
            );

          case 3: // Messagerie
            return <div>Messagerie pour prestataires BC</div>;

          default:
            return <div>Onglet non disponible</div>;
        }
      } else {
        // Pour les clients BC : structure directe avec rangs
        switch (activeTab) {
          case 0: // Suivi de la Commande
            return <SuiviDuMarche commande={entity} type="BC" />;

          // CORRECTION: Gérer les onglets dynamiques pour les acheteurs BC
          default:
            const tabName = tabs[activeTab];

            console.log('=== DEBUG TAB NAME RESOLUTION ===');
            console.log('Active tab index:', activeTab);
            console.log('Tab name:', tabName);
            console.log('All tabs:', tabs);

            // NOUVEAU: Gestion des onglets Consultation Rang X
            if (tabName && tabName.startsWith('Consultation Rang ')) {
              const rang = parseInt(tabName.match(/\d+/)?.[0] || '1');
              console.log('=== RENDU CONSULTATION BC ACHETEUR ===');
              console.log('Tab name:', tabName);
              console.log('Rang:', rang);
              console.log('Transferred:', entity.transferred);
              console.log('Status:', status);

              // NOUVEAU: Pour les rangs 2 et 3, vérifier si c'est un transfert acheteur
              const isTransfertAcheteur = entity.transferred && (rang === 2 || rang === 3);
              const shouldShowTransfertValidation = isTransfertAcheteur &&
                (status === 'Brouillon' || status === 'Brouillon acheteur' || status === 'À analyser');

              console.log('Is transfert acheteur:', isTransfertAcheteur);
              console.log('Should show transfert validation:', shouldShowTransfertValidation);

              return (
                <ConsultationBC
                  commande={entity}
                  rang={rang as 1 | 2 | 3}
                  errors={errors}
                  setErrors={setErrors}
                  setCommande={setEntity}
                  handleExport={handleExport}
                  validateConsultationFormBC={validateConsultationForm}
                  handleLancerConsultation={(r) => handleLancerConsultationBC(r, entity)}
                  handleAccepterCommande={handleAccepterCommande}
                  handleRefuserCommande={handleRefuserCommande}
                  viewOnly={shouldShowTransfertValidation ? false : isConsultationReadOnly}
                  acceptCGV={acceptCGV}
                  setAcceptCGV={setAcceptCGV}
                  printRef={printRef}
                  commandeType={commandeType}
                />
              );
            }

            // NOUVEAU: Gestion des onglets Offre Rang X
            if (tabName && tabName.startsWith('Offre Rang ')) {
              const rang = parseInt(tabName.match(/\d+/)?.[0] || '1');
              console.log('=== RENDU OFFRE BC ACHETEUR ===');
              console.log('Tab name:', tabName);
              console.log('Rang:', rang);

              return (
                <OffreBC
                  commande={entity}
                  rang={rang as 1 | 2 | 3}
                  viewOnly={false}
                  printRef={printRef}
                />
              );
            }

            // NOUVEAU: Messagerie
            if (tabName === 'Messagerie') {
              return <div>Messagerie pour acheteurs BC</div>;
            }

            return <div>Onglet "{tabName}" non disponible</div>;
        }
      }
    }
    else if (commandeType === 'BCI') {
      if (isPrestataireView) {
        // Pour les prestataires BC : structure simplifiée
        switch (activeTab) {
          case 0:

            console.log('=== RENDU ONGLET OFFRE BC PRESTATAIRE ===');
            console.log('Active tab:', activeTab);
            console.log('Entity:', entity);
            console.log('Rang prestataire:', entity.rang || 2);

            return (
              <OffreBCI
                commande={entity}
                rang={entity.rang || 2}
                viewOnly={false}
                // NOUVEAU: Passer les props CGV
                acceptCGV={acceptCGV}
                setAcceptCGV={setAcceptCGV}
                printRef={printRef}
              />
            );

          default:
            return <div>Onglet non disponible</div>;
        }
      } else {
        // Pour les clients BC : structure directe avec rangs
        const tabName = tabs[activeTab];

        switch (activeTab) {

          // CORRECTION: Gérer les onglets dynamiques pour les acheteurs BC
          case 0:

            console.log('=== DEBUG TAB NAME RESOLUTION ===');
            console.log('Active tab index:', activeTab);
            console.log('Tab name:', tabName);
            console.log('All tabs:', tabs);

            // NOUVEAU: Gestion des onglets Consultation Rang X
            if (tabName && tabName.startsWith('Consultation Rang ')) {
              const rang = parseInt(tabName.match(/\d+/)?.[0] || '1');
              console.log('=== RENDU CONSULTATION BC ACHETEUR ===');
              console.log('Tab name:', tabName);
              console.log('Rang:', rang);
              console.log('Transferred:', entity.transferred);
              console.log('Status:', status);

              // NOUVEAU: Pour les rangs 2 et 3, vérifier si c'est un transfert acheteur
              const isTransfertAcheteur = entity.transferred && (rang === 2 || rang === 3);
              const shouldShowTransfertValidation = isTransfertAcheteur &&
                (status === 'Brouillon' || status === 'Brouillon acheteur' || status === 'À analyser');

              console.log('Is transfert acheteur:', isTransfertAcheteur);
              console.log('Should show transfert validation:', shouldShowTransfertValidation);

              return (
                <ConsultationBC
                  commande={entity}
                  rang={rang as 1 | 2 | 3}
                  errors={errors}
                  setErrors={setErrors}
                  setCommande={setEntity}
                  handleExport={handleExport}
                  validateConsultationFormBC={validateConsultationForm}
                  handleLancerConsultation={(r) => handleLancerConsultationBC(r, entity)}
                  handleAccepterCommande={handleAccepterCommande}
                  handleRefuserCommande={handleRefuserCommande}
                  viewOnly={shouldShowTransfertValidation ? false : isConsultationReadOnly}
                  acceptCGV={acceptCGV}
                  setAcceptCGV={setAcceptCGV}
                  printRef={printRef}
                  commandeType={commandeType}
                />
              );
            }
            break;

          case 1:

            // NOUVEAU: Gestion des onglets Offre Rang X
            if (tabName && tabName.startsWith('Offre Rang ')) {
              const rang = parseInt(tabName.match(/\d+/)?.[0] || '1');
              console.log('=== RENDU OFFRE BC ACHETEUR ===');
              console.log('Tab name:', tabName);
              console.log('Rang:', rang);

              return (
                <OffreBCI
                  commande={entity}
                  rang={rang as 1 | 2 | 3}
                  viewOnly={false}
                  printRef={printRef}
                />
              );
            }
            break;
          default:
            return <div>Onglet "{tabName}" non disponible</div>;
        }
      }
    }
  };

  return <>{renderTabs()}</>;
};

export default SuiviEntityContent;